import { JobInterview, PaginationResults } from "src/types";
import {
  BulkInviteParams,
  GenerateFeedbackParams,
  InterviewInviteParams,
  InterviewMetrics,
  InterviewMetricsParams,
  InterviewPaginatedParams,
  SendReminderParams
} from "./type";
import { post, get, put } from "../utils";

export async function bulkInvite(
  body: BulkInviteParams
): Promise<{ invited: JobInterview[]; already_invited: JobInterview[] }> {
  return (await post({ path: "outdefine_hire/job_interview", body })).body;
}

export async function interviewInvite({ data, job_id }: InterviewInviteParams) {
  return (await bulkInvite({ data: [data], job_id })).invited[0];
}

export async function getInterviewsPaginated(
  queryParams: InterviewPaginatedParams
): Promise<PaginationResults<JobInterview>> {
  return (await get({ path: "outdefine_hire/job_interview", queryParams })).body;
}

export async function getInterview(
  queryParams: InterviewPaginatedParams
): Promise<JobInterview | undefined> {
  const result = (await getInterviewsPaginated(queryParams))?.data[0];
  // Soft sort in the frontend
  result.Transcripts = result.Transcripts?.sort((a, b) => a.index - b.index);
  return result;
}

export async function getInterviewMetrics(
  queryParams?: InterviewMetricsParams
): Promise<InterviewMetrics> {
  return (await get({ path: "outdefine_hire/job_interview/metrics", queryParams })).body.metrics;
}

export async function sendAllReminder(body: SendReminderParams): Promise<{ sent: number }> {
  return (await put({ path: "outdefine_hire/job_interview/remindAll", body })).body;
}

export async function sendReminder(body: { interview_id: number }): Promise<void> {
  await sendAllReminder(body);
}

export async function generateFeedback(queryParams: GenerateFeedbackParams) {
  return (await post({ path: "outdefine_hire/job_interview/generate-feedback", queryParams })).body
    ?.data;
}

export async function resetInterview(interview_id: number): Promise<void> {
  await put({ path: "outdefine_hire/job_interview/reset", body: { interview_id } });
}

export async function passInterview(interview_id: number): Promise<JobInterview> {
  return (await put({ path: `outdefine_hire/job_interview/pass`, suffix: interview_id.toString() }))
    .body?.interview;
}

export async function rejectInterview(interview_id: number): Promise<JobInterview> {
  return (
    await put({ path: `outdefine_hire/job_interview/reject`, suffix: interview_id.toString() })
  ).body?.interview;
}
